module.exports = __webpack_public_path__ + "static/media/cort2.71140207.jpeg";